import axios from 'axios'

const baseUrl = process.env.REACT_APP_BACKEND_URL

const autocompleteStations = async (formData, token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }

    const requestData = {
        "name": formData.name,
        "expandedResults": formData.expandedResults ? formData.expandedResults : false,
        "homeCountryCode": formData.homeCountryCode ? formData.homeCountryCode : undefined,
    }
    
    const response = await axios.post(baseUrl + `/api/station/autocompleteSearch`, requestData, config)
    
    return response.data
}

const getCountryList = async (token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }

    const response = await axios.post(baseUrl + `/api/station/getCountryList`, {}, config)
    
    // console.log(response)

    return response.data
}

const getStationsForCountry = async (countryCode, token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }

    const requestData = {
        "countryCode": countryCode
    }
    
    const response = await axios.post(baseUrl + `/api/station/getStationsForCountry`, requestData, config)

    // console.log(response)
    
    return response.data
}

const railStationService = {
    autocompleteStations,
    getCountryList,
    getStationsForCountry
}

export default railStationService